<template>
  <svgicon
    :class="$style.container"
    :name="name"
    :color="computedColor"
    :height="computedHeight"
  ></svgicon>
</template>

<script>
import themeVars from '@/assets/styles/variables.scss'

export default {
  name: 'base-icon',

  props: {
    name: { type: String, required: true },
    preload: { type: Array, default: () => [] },
    size: { type: String },
    color: { type: String },
    themeColor: { type: String },
    themeSize: { type: String }
  },

  computed: {
    computedColor() {
      return this.themeColor
        ? themeVars[`color-${this.themeColor}`]
        : this.color
    },

    computedHeight() {
      return this.themeSize ? themeVars[`size-${this.themeSize}`] : this.size
    }
  },

  created() {
    this.preload
      .concat(this.name)
      .forEach(name =>
        import(/* webpackChunkName: "Icon-[request]" */ `./icons/${name}`)
      )
  }
}
</script>

<style lang="scss" module>
.container {
  display: inline-block;
  height: 1em;
  vertical-align: middle;
}
</style>
